<form class="mc-spring-board" [formGroup]="createChecklistTemplateForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    <div class="mc-spring-board-stepper-header">
      Create Checklist Template
    </div>
  </mat-toolbar>

  <mat-stepper #stepper class="mc-spring-board-body mat-secondary mc-stepper-arrow" linear>
    <!-- Settings Form -->
    <mat-step formGroupName="settingsForm" [stepControl]="createChecklistTemplateForm.get('settingsForm')">
      <ng-template matStepLabel>
        <div class="mat-step-text-label">Settings</div>
        <div class="mat-step-optional mc-truncate mc-project-checklist-create-dialog-step-optional">{{ settingsStepLabel }}</div>
      </ng-template>

      <div class="mc-spring-board">
        <div class="mc-spring-board-body">
          <mc-project-checklist-settings-form #settingsForm [licenseId]="data.licenseId" mode="create-template" [showFormFooter]="false" [template]="template"></mc-project-checklist-settings-form>
        </div>

        <div class="mc-spring-board-form-footer">
          <div class="mc-form-buttons">
            <button type="button" mat-raised-button color="primary" matStepperNext>Next</button>
          </div>
        </div>
      </div>
    </mat-step>

    <!-- Columns -->
    <mat-step optional>
      <ng-template matStepLabel>
        <div class="mat-step-text-label">Columns</div>
        <div class="mat-step-optional mc-truncate mc-project-checklist-create-dialog-step-optional">{{ columnsStepLabel }}</div>
      </ng-template>

      <div class="mc-spring-board">
        <div class="mc-spring-board-body">
          <mc-project-checklist-columns-form #columnsForm [showFormFooter]="false" [template]="template"></mc-project-checklist-columns-form>
        </div>

        <div class="mc-spring-board-form-footer">
          <div class="mc-form-buttons">
            <button type="button" mat-stroked-button matStepperPrevious>Back</button>
            <button type="button" mat-raised-button color="primary" matStepperNext>Next</button>
          </div>
        </div>
      </div>
    </mat-step>

    <!-- Rows -->
    <mat-step *ngIf="createChecklistTemplateForm?.get('settingsForm.type')?.value === ProjectChecklistType.GenericList" [stepControl]="rowsForm?.checklistRowsForm" [optional]="rowsForm?.checklistRowsForm?.valid">
      <ng-template matStepLabel>
        <div class="mat-step-text-label">Rows</div>
        <div class="mat-step-optional mc-truncate mc-project-checklist-create-dialog-step-optional">{{ rowsStepLabel }}</div>
      </ng-template>

      <div class="mc-spring-board">
        <div class="mc-spring-board-body">
          <mc-project-checklist-rows-form #rowsForm [showFormFooter]="false" [template]="template" [type]="createChecklistTemplateForm.get('settingsForm.type').value"></mc-project-checklist-rows-form>
        </div>

        <div class="mc-spring-board-form-footer">
          <div class="mc-form-buttons">
            <button type="button" mat-stroked-button matStepperPrevious>Back</button>
            <button type="button" mat-raised-button color="primary" matStepperNext>Next</button>
          </div>
        </div>
      </div>
    </mat-step>

    <!-- Summary -->
    <mat-step>
      <ng-template matStepLabel>
        <div class="mat-step-text-label">Summary</div>
      </ng-template>

      <div class="mc-spring-board-form-body summary-tab mc-project-checklist-create-dialog-summary-tab">
        <p class="mc-form-text">A <b>{{ createChecklistTemplateForm?.get('settingsForm.type')?.value | mcProjectChecklistTypeDisplayText }}</b> checklist template will be created with the following:</p>
        <div class="mc-form-spacer"></div>

        <p class="mc-form-heading">Checklist Template Name</p>
        <p class="mc-form-text">{{ createChecklistTemplateForm?.get('settingsForm.name')?.value }}</p>
        <div class="mc-form-spacer"></div>

        <p class="mc-form-heading">Description</p>
        <p *ngIf="createChecklistTemplateForm?.get('settingsForm.description')?.value as description; else noChecklistDescription" class="mc-form-text">{{ description }}</p>
        <ng-template #noChecklistDescription>
          <p class="mc-form-note">No Description</p>
        </ng-template>
        <div class="mc-form-spacer"></div>

        <p class="mc-form-heading">Columns <span *ngIf="columns.length > 0">({{ columns.length }})</span></p>
        <ng-container *ngIf="columns?.length > 0; else noColumns">
          <ul class="mc-property-list">
            <li *ngFor="let column of columns; let index = index">
              <span class="mc-property-name">Column {{ index + 1 }}: </span>
              <span class="mc-property-value">{{ column.Name }}</span>
            </li>
          </ul>
        </ng-container>

        <ng-template #noColumns>
          <p class="mc-form-note">No Columns</p>
        </ng-template>
        <div class="mc-form-spacer"></div>

        <div *ngIf="(createChecklistTemplateForm?.get('settingsForm.type')?.value === ProjectChecklistType.GenericList)">
          <p class="mc-form-heading">Rows <span *ngIf="items.length > 0">({{ items.length }})</span></p>
          <div #displayGenericListRows *ngIf="items.length > 0; else noRows">
            <ul class="mc-property-list">
              <li *ngFor="let row of items; let index = index">
                <span class="mc-property-name">Row {{ index + 1 }}: </span>
                <span class="mc-property-value">{{ row.Name }}</span>
              </li>
            </ul>
          </div>
          <ng-template #noRows>
            <p class="mc-form-note">No Rows</p>
          </ng-template>
        </div>
      </div>

      <div class="mc-spring-board-form-footer">
        <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>

        <div class="mc-form-buttons">
          <button type="button" mat-stroked-button matStepperPrevious>Back</button>
          <button type="submit" mat-raised-button color="primary" matStepperNext>Create Checklist Template</button>
        </div>
      </div>
    </mat-step>

    <!-- Step Label Icons -->
    <ng-template matStepperIcon="edit" let-index="index">
      {{ index + 1 }}
    </ng-template>
    <ng-template matStepperIcon="done" let-index="index">
      {{ index + 1 }}
    </ng-template>
  </mat-stepper>

  <button type="button" mat-icon-button class="mc-dialog-floating-close-button" color="secondary-invert" tabindex="-1" (click)="closeDialog()">
    <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
  </button>

  <!-- Saving State -->
  <div *ngIf="(savingState.loading$ | async)" class="mc-loader mc-project-checklist-create-dialog-saving-pane">
    <p class="mc-form-text">The checklist template is being created.</p>

    <mat-progress-bar class="mc-progress-bar-large" color="notice" mode="indeterminate"></mat-progress-bar>

    <p class="mc-text-muted mc-project-checklist-create-dialog-saving-progress-text">Creating new checklist template</p>
  </div>
</form>